import { TransactionStatusModalContent } from '@modals/Billing/TransactionStatusModal/components/Content';
import { Elements } from '@stripe/react-stripe-js';
import { getStripePromise } from 'app/http/stripeConfig';
import { useMemo } from 'react';

type TProps = {
  billingAccountId?: string;
  chargeId?: string;
  paymentIntentId?: string;
  pics: string;
  onSuccess: () => void;
};

export const TransactionStatusModal = ({ billingAccountId, chargeId, paymentIntentId, pics, onSuccess }: TProps) => {
  const stripePromise = useMemo(() => getStripePromise(), []);
  return (
    <Elements stripe={stripePromise}>
      <TransactionStatusModalContent
        billingAccountId={billingAccountId}
        chargeId={chargeId}
        paymentIntentId={paymentIntentId}
        pics={pics}
        onSuccess={onSuccess}
      />
    </Elements>
  );
};
